module.exports = __webpack_public_path__ + "static/media/shovel-snow.cbccfc83.svg";